import { render, staticRenderFns } from "./pdfFile.vue?vue&type=template&id=3fe00e2c&scoped=true"
import script from "./pdfFile.vue?vue&type=script&lang=js"
export * from "./pdfFile.vue?vue&type=script&lang=js"
import style0 from "./pdfFile.vue?vue&type=style&index=0&id=3fe00e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe00e2c",
  null
  
)

export default component.exports